import { render, staticRenderFns } from "./CompanyComplete.vue?vue&type=template&id=eb0f471c&"
import script from "./CompanyComplete.vue?vue&type=script&lang=ts&"
export * from "./CompanyComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports